import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import Documentation from './Documentation';
import Announcement from './Announcement';

const Documentations = ({ activeTab, setActiveTab, showNav, hasProjectDocumentations }) => {
    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'documentation'
                            })}
                            onClick={() => {
                                setActiveTab('documentation');
                            }}
                        >
                            Documentações
                        </NavLink>
                    </NavItem>
                    {hasProjectDocumentations && (
                        <NavItem>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({
                                    active: activeTab === 'projectdocumentation'
                                })}
                                onClick={() => {
                                    setActiveTab('projectdocumentation');
                                }}
                            >
                                Documentações de Projeto
                            </NavLink>
                        </NavItem>
                    )}
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'announcements'
                            })}
                            onClick={() => {
                                setActiveTab('announcements');
                            }}
                        >
                            Comunicados
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="documentation">
                    <Col sm="12">
                        <Documentation />
                    </Col>
                </TabPane>
                {hasProjectDocumentations && (
                    <TabPane tabId="projectdocumentation">
                        <Col sm="12">
                            <Documentation
                                scope="project"
                                labelTitle="Documentações de Projeto"
                            />
                        </Col>
                    </TabPane>
                )}
                <TabPane tabId="announcements">
                    <Col sm="12">
                        <Announcement />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default Documentations;
